import React from 'react';
import LegacyPopover, { PopoverProps } from './Popover.legacy';
import AlphaPopover from './Popover.alpha';

const Component = process.env.IS_LEGACY ? LegacyPopover : AlphaPopover;
export default Component as React.FC<PopoverProps>;
export type { PopoverProps };
